export default __webpack_public_path__ + "static/media/LAS0300.34I-30395_-17751_0.a0ce802f.jpg";